import { bootstrapApplication } from '@angular/platform-browser';

import { AppComponent } from './app/app.component';
import { appConfig } from './app/app.config';
import {
  installChunkLoadRecovery,
  markChunkReloadRecovered,
  recoverStaleChunk,
} from './chunk-load-recovery';

installChunkLoadRecovery(window);

bootstrapApplication(AppComponent, appConfig)
  .then(() => {
    markChunkReloadRecovered(window);
  })
  .catch((err: unknown) => {
    if (!recoverStaleChunk(err, window)) {
      console.error(err);
    }
  });
